import React from "react";
import { TokenProvider } from "./components/Firebase/TokenContext";
import Login from "./Pages/Login";

const App = () => (
  <TokenProvider>
    <Login />
  </TokenProvider>
);

export default App;
